import DataTable, { createTheme } from "react-data-table-component";
import moment from "moment";
import web3Config from "../../../Web3/web3Config";

export const ListTable = ({ DataList, type }) => {
  const buyColumns = [
    {
      name: "INFI Token",
      selector: (row) => parseFloat(row._infiToken).toFixed(6),
      sortable: true,
    },
    {
      name: "INFI Price ($)",
      selector: (row) => parseFloat(row._infiPrice).toFixed(6),
      sortable: true,
    },
    {
      name: "USDT Amount",
      selector: (row) => parseFloat(row._usdtAmount).toFixed(6),
      sortable: true,
    },
    {
      name: "Phase",
      selector: (row) => row._phase || 1,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) =>
        moment(new Date(row._datetime)).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "Trx Hash",
      selector: (row) => (
        <a target="_blank" href={`${web3Config.Explore}tx/${row._hash}`}>
          {row._hash.substring(0, 10)}...
        </a>
      ),
      sortable: true,
    },
  ];

  const cdexColumns = [
    {
      name: "From Currency",
      selector: (item) => item._fromCurrency,
      sortable: true,
    },
    {
      name: "To Currency",
      selector: (item) => item._toCurrency,
      sortable: true,
    },
    {
      name: "From Amount",
      selector: (row) => parseFloat(row._fromAmount).toFixed(6),
      sortable: true,
    },
    {
      name: "To Amount",
      selector: (row) => parseFloat(row._toAmount).toFixed(6),
      sortable: true,
    },
    {
      name: "Price",
      selector: (row) => parseFloat(row._price).toFixed(6),
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => Number(row._trxType),
      sortable: true,
      format: (row) => <span>{row._trxType == 1 ? "Swap" : ""}</span>,
    },
    {
      name: "Date",
      selector: (row) =>
        moment(new Date(row._datetime)).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "Trx Hash",
      selector: (row) => (
        <a target="_blank" href={`${web3Config.Explore}tx/${row._hash}`}>
          {row._hash.substring(0, 10)}...
        </a>
      ),
      sortable: true,
    },
  ];

  const claimColumns = [
    {
      name: "INFI Token",
      selector: (row) => parseFloat(row._infiToken).toFixed(6),
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) =>
        moment(new Date(row._datetime)).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "Trx Hash",
      selector: (row) => (
        <a target="_blank" href={`${web3Config.Explore}tx/${row._hash}`}>
          {row._hash.substring(0, 10)}...
        </a>
      ),
      sortable: true,
    },
  ];

  const stakingColumns = [
    {
      name: "Currency",
      selector: (item) => item._currency,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => parseFloat(row._trxAmount).toFixed(6),
      sortable: true,
    },
    {
      name: "WBTC Reward",
      selector: (row) => parseFloat(row._wbtcReward).toFixed(6),
      sortable: true,
    },
    {
      name: "Penalty",
      selector: (item) => item._penalty,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => Number(row._trxType),
      sortable: true,
      format: (row) => (
        <span>
          {row._trxType == 1
            ? "Staked"
            : row._trxType == 2
            ? "UnStaked / Sold"
            : row._trxType == 3
            ? "Claimed Reward"
            : row._trxType == 4
            ? "Unstake"
            : row._trxType == 5
            ? "Restake"
            : ""}
        </span>
      ),
    },
    {
      name: "Date",
      selector: (row) =>
        moment(new Date(row._datetime)).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "Trx Hash",
      selector: (row) => (
        <a target="_blank" href={`${web3Config.Explore}tx/${row._hash}`}>
          {row._hash.substring(0, 10)}...
        </a>
      ),
      sortable: true,
    },
  ];

  const data = [
    {
      id: 1,
      token: "#123",
      amount: "123",
      phase: "1",
      date: "24/11/2023",
      action: "...",
    },
    {
      id: 2,
      token: "#123",
      amount: "1988",
      phase: "2",
      date: "24/11/2023",
      action: "...",
    },
    {
      id: 3,
      token: "#123",
      amount: "1988",
      phase: "3",
      date: "24/11/2023",
      action: "...",
    },
  ];
  createTheme(
    "solarized",
    {
      text: {
        primary: "#000",
        secondary: "#fff",
      },
      background: {
        default: "transparent",
      },
      context: {
        text: "#FFFFFF",
      },
      divider: {
        default: "rgba(var(--bs-dark-rgb),var(--bs-border-opacity))",
      },
      action: {
        button: "rgba(0,0,0,.54)",
        hover: "rgba(0,0,0,.08)",
        disabled: "rgba(0,0,0,.12)",
      },
    },
    "dark"
  );

  const customStyles = {
    rows: {
      style: {
        minHeight: "50px", // override the row height
        fontSize: "1rem",
      },
    },
    head: {
      style: {
        minHeight: "50px",
        fontSize: "1rem",
        background: "linear-gradient(90deg, #93D9AC 0%, #85DEF5 100%)",
      },
    },
    headCells: {
      style: {
        color: "#000",
        fontWeight: "600",
      },
    },
    cells: {
      style: {
        border: "none",
      },
    },
    pagination: {
      style: {
        background: "linear-gradient(90deg, #93D9AC 0%, #85DEF5 100%)", // Change pagination color to blue
        // fontSize: "1rem",
        color: "#000",
        fontWeight: "600",
      },
    }
  };

  return type == 1 ? (
    <DataTable
      columns={buyColumns}
      data={DataList}
      theme="solarized"
      customStyles={customStyles}
      pagination
    />
  ) : type == 3 ? (
    <DataTable
      columns={cdexColumns}
      data={DataList}
      theme="solarized"
      customStyles={customStyles}
      pagination
    />
  ) : type == 4 ? (
    <DataTable
      columns={stakingColumns}
      data={DataList}
      theme="solarized"
      customStyles={customStyles}
      pagination
    />
  ) : (
    <DataTable
      columns={claimColumns}
      data={DataList}
      theme="solarized"
      customStyles={customStyles}
      pagination
    />
  );
};
